module.exports = "<div class=\"rendered-tree mt-1 mb-2\" #container></div>"